import React from 'react';
import Backdrop from '../backdrop/backdrop.component';
import Button from '../button/button.component';
import { useHistory } from 'react-router-dom';
import './delete-quiz.styles.scss';

interface IProps {
    quizId?: number;
    questionId?: number;
    deleteState: boolean;
    setDeleteState: (condition: boolean) => void;
    index?: number;
    setIndex?: (index: number) => void;
    quiz?: boolean;
    question?: boolean;
}

export default function DeletePrompt({
    quizId,
    questionId,
    deleteState,
    setDeleteState,
    index,
    setIndex,
    quiz,
}: IProps) {
    const history = useHistory();
    const handleDeleteQuestion = () => {
        if (index !== undefined && setIndex !== undefined) {
            setIndex(index);
            history.push(`/quiz/${quizId}/question/delete/${questionId}`);
        }
    };
    return (
        <div className="delete-prompt">
            <Backdrop
                className="fixed"
                show={deleteState}
                clickHandler={setDeleteState}
            >
                <div className="delete-prompt__modal">
                    <div className="delete-prompt__modal__message">
                        <span>
                            {quiz
                                ? 'Are you sure want to delete this quiz?.'
                                : 'Are you sure want to delete this question?'}
                        </span>
                    </div>
                    <div className="delete-prompt__modal__button">
                        <Button
                            className="dark"
                            onClick={() => setDeleteState(false)}
                        >
                            Cancel
                        </Button>
                        <Button
                            className="delete"
                            onClick={() =>
                                quiz
                                    ? history.push(`/quiz/delete/${quizId}`)
                                    : handleDeleteQuestion()
                            }
                        >
                            Delete
                        </Button>
                    </div>
                </div>
            </Backdrop>
        </div>
    );
}
